import { createAction } from '@reduxjs/toolkit';

import { SetStatsPayload } from './types';

export const setStats = createAction<SetStatsPayload>('app/stats/set');
